module.exports = __webpack_public_path__ + "img/account-opening.e2c4e69e.png";